module.exports = __webpack_public_path__ + "img/dress5.10616b1c.jpeg";